import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataOffers from "@/data/AdminPanel/DataOffers";
import ApiEnter from "@/api/ApiEnter";
import ApiOffer from "@/api/ApiOffer";
import sweetalert from "sweetalert";
import ApiAdmin from "@/api/ApiAdmin";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@/data/CKeditor/config";
import UtilGeneral from "@/util/Common/UtilGeneral";
import { EAdminPanelOffersPriceFor, EOffersColor } from "@/struct/admin-panel/EAdminPanelOffersPriceFor";
let OfferEdit = class OfferEdit extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.editorConfig = CKEditor.editorConfig(ApiEnter.CurrentSessionUUID);
        this.editorShortConfig = CKEditor.editorOffersShort();
        this.Breadcrumbs = DataOffers.OfferEditBreadcrumbs;
        this.NewCategoryCardDesign = ["Blue", "Orange", "Transparent"];
        this.OffersCategories = [];
        this.ActiveOffers = []; //
        this.ActiveOfferID = 0;
        this.ActiveOffer = null;
        this.priceForEnum = EAdminPanelOffersPriceFor;
        this.priceForItems = [
            {
                text: "al mese",
                value: EAdminPanelOffersPriceFor.AlMese,
            },
            {
                text: "1° mese",
                value: EAdminPanelOffersPriceFor.OneMese,
            },
            {
                text: "con 2 mesi inclusi",
                value: EAdminPanelOffersPriceFor.ConTwoMesiInclusi,
            },
            {
                text: "con 3 mesi inclusi",
                value: EAdminPanelOffersPriceFor.ConThreeMesiInclusi,
            },
            {
                text: "other",
                value: EAdminPanelOffersPriceFor.Other,
            },
        ];
        this.colorItems = [
            {
                text: "light gray",
                value: EOffersColor.LightGray,
            },
            {
                text: "light red",
                value: EOffersColor.LightRed,
            },
            {
                text: "light blue",
                value: EOffersColor.LightBlue,
            },
        ];
        this.newOfferCustomisation = {
            free: {
                value: true,
                color: EOffersColor.LightGray,
                bold: false,
            },
            rates_abroad: {
                value: true,
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data_two: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            additional_data_three: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
            int_minutes: {
                value: "",
                color: EOffersColor.LightGray,
                bold: false,
            },
        };
        this.newOffer = {
            name: "",
            priority: "",
            publish: true,
            category: [],
            price: "",
            data: "",
            data_eu: "",
            sms: "",
            min: "",
            additional_data: "",
            countries: "",
            rates_abroad: true,
            free: true,
            activation_info: "",
            display_roaming: true,
            overview: "",
            note: "",
            design: "",
            photo_list: null,
            photo_list_name: "",
            alt_list: "",
            photo_slide: null,
            photo_slide_name: "",
            alt_slide: "",
            photo_slide_lg: null,
            photo_slide_lg_name: null,
            alt_slide_lg: "",
            photo_slide_m: null,
            photo_slide_m_name: "",
            alt_slide_m: "",
            display_offers: true,
            display_home: false,
            display_slider: false,
            landing_only: false,
            no_index: false,
            active: "active",
            tariff_overview: "",
            prospects_info: null,
            prospects_info_name: "",
            contract: null,
            contract_name: "",
            is_porting: true,
            title: "",
            description: "",
            keywords: "",
            url: "",
            price_for: EAdminPanelOffersPriceFor.AlMese,
            other_text: "",
        };
        this.HasLoading = false;
        this.LoadingDataFromBSS = true;
        this.IsNewFileData = {
            photo_list: false,
            photo_slide: false,
        };
    }
    async GetActiveOffers() {
        const response = await ApiOffer.GetActiveOffers(ApiEnter.CurrentSessionUUID);
        if (typeof response != "boolean") {
            this.ActiveOffers = response;
            this.ActiveOffers.unshift({
                ID: null,
                Title: "No matching",
            });
        }
        else {
            sweetalert({
                title: this.$t("general.error"),
                text: "Error to get offers from BSS",
                icon: "info",
            });
        }
        this.LoadingDataFromBSS = false;
    }
    async GetOfferInfo() {
        const offerInfo = await ApiOffer.GetOfferByUUID(ApiEnter.CurrentSessionUUID, this.CurrentOfferUUID);
        if (offerInfo == undefined) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            }).then(() => {
                this.$router.go(-1);
            });
            return;
        }
        this.newOffer.name = offerInfo.name;
        this.newOffer.priority = offerInfo.priority;
        this.newOffer.publish = offerInfo.publish;
        this.newOffer.category = offerInfo.category.split(",");
        if (offerInfo.additional_data_style != null) {
            const style = JSON.parse(offerInfo.additional_data_style);
            this.newOfferCustomisation.additional_data.bold = style.bold;
            this.newOfferCustomisation.additional_data.color = style.color;
        }
        if (offerInfo.additional_data_two_style != null) {
            const style = JSON.parse(offerInfo.additional_data_two_style);
            this.newOfferCustomisation.additional_data_two.bold = style.bold;
            this.newOfferCustomisation.additional_data_two.color = style.color;
        }
        if (offerInfo.additional_data_three_style != null) {
            const style = JSON.parse(offerInfo.additional_data_three_style);
            this.newOfferCustomisation.additional_data_three.bold = style.bold;
            this.newOfferCustomisation.additional_data_three.color = style.color;
        }
        if (offerInfo.free_style != null) {
            const style = JSON.parse(offerInfo.free_style);
            this.newOfferCustomisation.free.bold = style.bold;
            this.newOfferCustomisation.free.color = style.color;
        }
        if (offerInfo.rates_abroad_style != null) {
            const style = JSON.parse(offerInfo.rates_abroad_style);
            this.newOfferCustomisation.rates_abroad.bold = style.bold;
            this.newOfferCustomisation.rates_abroad.color = style.color;
        }
        if (offerInfo.int_min_style != null) {
            const style = JSON.parse(offerInfo.int_min_style);
            this.newOfferCustomisation.int_minutes.bold = style.bold;
            this.newOfferCustomisation.int_minutes.color = style.color;
        }
        this.newOffer.price = String(offerInfo.price);
        this.newOffer.data = offerInfo.data;
        this.newOffer.data_eu = offerInfo.data_eu;
        this.newOffer.sms = offerInfo.sms;
        this.newOffer.min = offerInfo.min;
        this.newOfferCustomisation.additional_data.value = offerInfo.additional_data || "";
        this.newOfferCustomisation.additional_data_two.value = offerInfo.additional_data_two || "";
        this.newOfferCustomisation.additional_data_three.value = offerInfo.additional_data_three || "";
        this.newOfferCustomisation.int_minutes.value = offerInfo.int_min;
        this.newOffer.countries = offerInfo.countries;
        this.newOfferCustomisation.rates_abroad.value = offerInfo.rates_abroad;
        this.newOfferCustomisation.free.value = offerInfo.free;
        this.newOffer.activation_info = offerInfo.activation_info;
        this.newOffer.display_roaming = offerInfo.display_roaming;
        this.newOffer.overview = offerInfo.overview;
        this.newOffer.note = offerInfo.note;
        this.newOffer.design = offerInfo.design;
        this.newOffer.photo_list = offerInfo.photo_list
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.photo_list).then(response => {
                this.newOffer.photo_list = new File([new Blob([response.data])], offerInfo.photo_list.split("/")[8]);
            })
            : null;
        this.newOffer.photo_list_name = offerInfo.photo_list;
        this.newOffer.alt_list = offerInfo.alt_list;
        this.newOffer.photo_slide = offerInfo.photo_slide
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.photo_slide).then(response => {
                this.newOffer.photo_slide = new File([new Blob([response.data])], offerInfo.photo_slide.split("/")[8]);
            })
            : null;
        this.newOffer.photo_slide_name = offerInfo.photo_slide;
        this.newOffer.alt_slide = offerInfo.alt_slide;
        this.newOffer.photo_slide_lg = offerInfo.photo_slide_lg
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.photo_slide_lg).then(response => {
                this.newOffer.photo_slide_lg = new File([new Blob([response.data])], offerInfo.photo_slide_lg.split("/")[8]);
            })
            : null;
        this.newOffer.photo_slide_lg_name = offerInfo.photo_slide_lg;
        this.newOffer.alt_slide_lg = offerInfo.alt_slide_lg;
        this.newOffer.photo_slide_m = offerInfo.photo_slide_m
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.photo_slide_m).then(response => {
                this.newOffer.photo_slide_m = new File([new Blob([response.data])], offerInfo.photo_slide_m.split("/")[8]);
            })
            : null;
        this.newOffer.photo_slide_m_name = offerInfo.photo_slide_m;
        this.newOffer.alt_slide_m = offerInfo.alt_slide_m;
        this.newOffer.display_offers = offerInfo.display_offers;
        this.newOffer.display_home = offerInfo.display_home;
        this.newOffer.display_slider = offerInfo.display_slider;
        this.newOffer.landing_only = offerInfo.landing_only;
        this.newOffer.no_index = offerInfo.no_index;
        this.newOffer.active = offerInfo.active === 1 ? "active" : "non_active";
        this.newOffer.tariff_overview = offerInfo.tariff_overview;
        this.newOffer.prospects_info = offerInfo.prospects_info
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.prospects_info).then(response => {
                this.newOffer.prospects_info = new File([new Blob([response.data])], offerInfo.prospects_info.split("/")[8]);
            })
            : null;
        this.newOffer.prospects_info_name = offerInfo.prospects_info;
        this.newOffer.contract = offerInfo.contract
            ? ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, offerInfo.contract).then(response => {
                this.newOffer.contract = new File([new Blob([response.data])], offerInfo.contract.split("/")[8]);
            })
            : null;
        this.newOffer.contract_name = offerInfo.contract;
        this.newOffer.price_vodafone = offerInfo.price_vodafone;
        this.newOffer.price_others = offerInfo.price_others;
        this.newOffer.title = offerInfo.title || "";
        this.newOffer.description = offerInfo.description || "";
        this.newOffer.keywords = offerInfo.keywords || "";
        this.newOffer.url = offerInfo.url || "";
        this.newOffer.price_for = offerInfo.price_for;
        this.newOffer.other_text = offerInfo.other_text;
        this.ActiveOffer = JSON.parse(offerInfo.external_data);
        this.ActiveOfferID = offerInfo.external_id;
    }
    async getOffersCategories() {
        try {
            this.OffersCategories = await ApiOffer.GetOfferCategories(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    async OnClickSubmit() {
        this.HasLoading = true;
        try {
            const activeOffer = this.ActiveOfferID ? JSON.stringify(this.ActiveOffer) : "";
            const additionalDataStyle = {
                color: this.newOfferCustomisation.additional_data.color,
                bold: this.newOfferCustomisation.additional_data.bold,
            };
            const additionalDataTwoStyle = {
                color: this.newOfferCustomisation.additional_data_two.color,
                bold: this.newOfferCustomisation.additional_data_two.bold,
            };
            const additionalDataThreeStyle = {
                color: this.newOfferCustomisation.additional_data_three.color,
                bold: this.newOfferCustomisation.additional_data_three.bold,
            };
            const freeStyle = {
                color: this.newOfferCustomisation.free.color,
                bold: this.newOfferCustomisation.free.bold,
            };
            const ratesAbroadStyle = {
                color: this.newOfferCustomisation.rates_abroad.color,
                bold: this.newOfferCustomisation.rates_abroad.bold,
            };
            const intMinutesStyle = {
                color: this.newOfferCustomisation.int_minutes.color,
                bold: this.newOfferCustomisation.int_minutes.bold,
            };
            const response = await ApiOffer.UpdateOfferInfo(this.newOffer.name, this.newOffer.priority, this.newOffer.publish ? 1 : 0, this.newOffer.category.join(), this.newOffer.price, this.newOffer.data, this.newOffer.data_eu, this.newOffer.sms, this.newOffer.min, this.newOfferCustomisation.additional_data.value, this.newOfferCustomisation.int_minutes.value, this.newOffer.countries, this.newOfferCustomisation.rates_abroad.value ? 1 : 0, this.newOfferCustomisation.free.value ? 1 : 0, this.newOffer.activation_info, this.newOffer.display_roaming ? 1 : 0, this.newOffer.overview, this.newOffer.note, this.newOffer.design, this.newOffer.photo_list != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_list, this.newOffer.photo_list_name)) : "", this.newOffer.alt_list, this.newOffer.photo_slide != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide, this.newOffer.photo_slide_name)) : "", this.newOffer.alt_slide, this.newOffer.photo_slide_lg != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide_lg, this.newOffer.photo_slide_lg_name)) : "", this.newOffer.alt_slide_lg, this.newOffer.photo_slide_m != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.photo_slide_m, this.newOffer.photo_slide_m_name)) : "", this.newOffer.alt_slide_m, this.newOffer.display_offers ? 1 : 0, this.newOffer.display_home ? 1 : 0, this.newOffer.display_slider ? 1 : 0, this.newOffer.landing_only ? 1 : 0, this.newOffer.no_index ? 1 : 0, this.newOffer.active === "active" ? 1 : 0, this.newOffer.tariff_overview, this.newOffer.prospects_info != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info, this.newOffer.prospects_info_name)) : "", this.newOffer.contract != null ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.contract, this.newOffer.contract_name)) : "", this.newOffer.title, this.newOffer.description, this.newOffer.keywords, this.newOffer.url, ApiEnter.CurrentSessionUUID, this.CurrentOfferUUID, activeOffer, this.ActiveOfferID, this.newOffer.price_for, this.newOffer.other_text, JSON.stringify(additionalDataStyle), this.newOfferCustomisation.additional_data_two.value, JSON.stringify(additionalDataTwoStyle), this.newOfferCustomisation.additional_data_three.value, JSON.stringify(additionalDataThreeStyle), JSON.stringify(freeStyle), JSON.stringify(ratesAbroadStyle), JSON.stringify(intMinutesStyle));
            if (typeof response == "boolean") {
                sweetalert({
                    title: this.$t("general.success"),
                    text: this.$t("general.success_updated"),
                    icon: "success",
                }).then(() => {
                    this.$router.go(-1);
                });
            }
            else {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
            }
        }
        catch (e) {
            console.error(e);
            await sweetalert({
                title: this.$t("general.error"),
                text: this.$t("general.request_error"),
                icon: "info",
            });
        }
        this.HasLoading = false;
    }
    CopyLink(link) {
        UtilGeneral.CopyLink(link);
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    ValidateSeoUrl() {
        this.newOffer.url = this.Translit(this.newOffer.url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
    }
    async DownloadPhotoList() {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, this.newOffer.photo_list_name).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = this.newOffer.photo_list_name.split("/")[8];
            a.click();
        });
    }
    async DownloadPhotoSlide(filename) {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, filename).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = filename.split("/")[8];
            a.click();
        });
    }
    async DownloadProspectsInfo() {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info_name).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = this.newOffer.prospects_info_name.split("/")[8];
            a.click();
        });
    }
    async DownloadContract() {
        await ApiAdmin.GetFiles(ApiEnter.CurrentSessionUUID, this.newOffer.contract_name).then(response => {
            let a = document.createElement("a");
            let file = new Blob([response]);
            a.href = URL.createObjectURL(file);
            a.download = this.newOffer.contract_name.split("/")[8];
            a.click();
        });
    }
    ChangeActiveOffer() {
        this.ActiveOffer = this.ActiveOffers.find(item => item?.ID == this.ActiveOfferID);
    }
    OnChangeLandingOnly(value) {
        if (value) {
            this.newOffer.display_offers = false;
            this.newOffer.display_home = false;
            this.newOffer.display_slider = false;
        }
    }
    created() {
        this.CurrentOfferUUID = this.$route.params.offer_uuid;
        this.getOffersCategories();
        this.GetActiveOffers();
        this.GetOfferInfo();
    }
};
OfferEdit = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], OfferEdit);
export default OfferEdit;
